<div class="grid">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoListar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoListar">
			<div class="formgroup" *ngIf="permissaoInserir || permissaoInserirIdentificada">
				<div class="p-fluid p-formgrid grid">
					<div class="field col-12 md:col-4">
						<p-splitButton label="Novo" icon="pi pi-plus"
						 [model]="itemsMenuBotao" styleClass="p-button-outlined sm:w-9rem"
							(onClick)="redirecionarSaidaNormal()" ></p-splitButton>
					</div>
				</div>
			</div>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="saidasEstoque" dataKey="id" [rows]="10" [loading]="loadingTable" [rowHover]="true"
				[paginator]="true" [globalFilterFields]="['descricaoItem', 'nomeProfissional']" responsiveLayout="stack"
				styleClass=" p-datatable-sm">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<div class="flex flex-column sm:flex-row w-full">
							<div class="p-fluid sm:w-12rem sm:mr-2">
								
								<label htmlFor="filtroData">Mês/ano</label>
								<p-calendar view="month" dateFormat="mm/yy" placeholder="Selecione" [showIcon]="true" [readonlyInput]="true"
									[(ngModel)]="filtroDataTransacao" (ngModelChange)="buscarDiasComRegistro()">
								</p-calendar>
							</div>
							<div class="p-fluid sm:mr-2">
								<label htmlFor="filtroCompetencia">Dia</label>
									<p-dropdown [options]="diasComSaidas" placeholder="Selecione" optionLabel="label" optionValue="value"
										name="filtroCompetencia" emptyMessage="Nenhum registro" [disabled]="!filtroDataTransacao"
										[(ngModel)]="diaSaidaSelecionado" (onChange)="carregarSaidasEstoque()">
									</p-dropdown>
							</div>

						</div>
						<div class="p-fluid mt-2 sm:mt-4">
							<div class="flex">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text" #filter (input)="buscar(dt1, $event)" placeholder="Buscar"
										class="w-full" />
								</span>
								<span class="ml-2">
									<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
										pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
								</span>
							</div>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th>
							Data da Saída
						</th>
						<th pSortableColumn="descricaoItem">
							Produto
							<p-sortIcon field="descricaoItem">
							</p-sortIcon>
						</th>
						<th pSortableColumn="quantidade">
							Quantidade
							<p-sortIcon field="quantidade">
							</p-sortIcon>
						</th>
						<th pSortableColumn="nomeProfissional">
							Atendente
							<p-sortIcon field="nomeProfissional">
							</p-sortIcon>
						</th>
						<th>
							Tipo
						</th>
						<th style="text-align: center;">
							<div>
								Ações
							</div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td>
							{{item.data | date:'dd/MM/yyyy'}}
						</td>
						<td>
							{{item.descricaoItem }}
						</td>
						<td>
							{{item.quantidade }} {{item.descricaoUnidadeMedida }}
						</td>
						<td>
							{{item.nomeProfissional }}
						</td>
						<td>
							<span *ngIf="item.comandaId > 0" class="product-badge bg-cyan-400 text-cyan-900">
								IDENTIFICADA
							</span>
							<span *ngIf="item.comandaId === 0" class="product-badge bg-green-300 text-green-900">
								NORMAL
							</span>
						</td>
						<td style="text-align: center;">
							<button *ngIf="permissaoExcluir" pButton pRipple
								pTooltip="Excluir" icon="pi pi-trash" (click)="excluir(item.id)"
								class="p-button-danger mr-2 mb-2 sm"></button>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando saídas. Por favor aguarde.</td>
					</tr>
				</ng-template>
			</p-table>
			<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
		</div>
	</div>
</div>